import {createTextMask} from 'redux-form-input-masks';

export const phone = createTextMask({pattern: '(99) 9999-9999'});
export const phoneCell = createTextMask({pattern: '(99) 9 9999-9999'});
export const zipCode = createTextMask({pattern: '99999-999'});
export const cpf = createTextMask({pattern: '999.999.999-99'});
export const birthday = createTextMask({pattern: '99/99/9999'});
